import Vue from 'vue'
import Vuex from 'vuex'

import mattressModels from '@/data/mattressModels'

Vue.use(Vuex)

const models = {
    namespaced: true,
    state: {
        mattressModels: mattressModels
    },
    mutations: {
    },
    getters: {
        mattressModels (state) {
            return state.mattressModels
        }
    },
    actions: {
    }
}

export default models
